import { render, staticRenderFns } from "./EventListSettings.vue?vue&type=template&id=099f0c98"
import script from "./EventListSettings.vue?vue&type=script&lang=js"
export * from "./EventListSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports